module.exports = __webpack_public_path__ + "static/media/americanExpress.523bd2c4.svg";